import React, { useState } from 'react';
import PropTypes from 'prop-types';
import cronstrue from 'cronstrue';
import 'ace-builds';
import AceEditor from 'react-ace';
import ace from 'ace-builds/src-noconflict/ace';
import 'ace-builds/src-noconflict/mode-json';
import 'ace-builds/src-noconflict/theme-github';
// Vite replacement for webpack-resolver: resolve the json worker as an asset URL.
import jsonWorkerUrl from 'ace-builds/src-noconflict/worker-json?url';
ace.config.setModuleUrl('ace/mode/json_worker', jsonWorkerUrl);
import {
  useMediaQuery,
  Box,
  Tabs,
  Tab,
  Paper,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  TableContainer,
  TextField,
  Divider,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Grid,
  Button,
  Container,
} from '@mui/material';
import momentTz from 'moment-timezone';

import useSchedule from '../../hooks/Schedule';
import useConfirmation from '../../hooks/Confirmation';
import { useStyles } from './styles';
import AxlDateTimePicker from 'components/AxlDateTimePicker/index';

function TabPanel(props) {
  const { children, value, index, items } = props;

  return (
    <div role="tabpanel" hidden={value !== index} id={`vertical-tabpanel-${index}`} aria-labelledby={`vertical-tab-${index}`}>
      {value === index && <Box>{children}</Box>}
    </div>
  );
}

function ScheduleTable(props) {
  const { items, onTrigger } = props;
  const { classes } = useStyles();

  return (
    items && (
      <TableContainer component={Paper}>
        <Table aria-label="simple table">
          <TableHead>
            <TableRow>
              <TableCell>Name</TableCell>
              <TableCell>Type</TableCell>
              <TableCell>Schedule</TableCell>
              <TableCell>Time Zone</TableCell>
              <TableCell>Start</TableCell>
              <TableCell>End</TableCell>
              <TableCell>Snap To</TableCell>
              <TableCell>Action</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {items?.length &&
              items.map((item) => (
                <TableRow hover key={`item-${item.id}`} className={!item.active ? classes.strikeText : undefined}>
                  <TableCell>{item.name}</TableCell>
                  <TableCell>{item.type}</TableCell>
                  <TableCell>
                    <strong>
                      {cronstrue.toString(item.schedule)}
                      <br />({item.schedule})
                    </strong>
                  </TableCell>
                  <TableCell>{item.time_zone}</TableCell>
                  <TableCell>{item.start}</TableCell>
                  <TableCell>{item.end}</TableCell>
                  <TableCell>{item.snap_to}</TableCell>
                  <TableCell>
                    <Button onClick={onTrigger(item)} variant="contained" color="primary">
                      View
                    </Button>
                  </TableCell>
                </TableRow>
              ))}
          </TableBody>
        </Table>
      </TableContainer>
    )
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  value: PropTypes.any.isRequired,
};

function Schedule(props) {
  const { classes } = useStyles();
  const isMobile = useMediaQuery('(max-width:600px)');

  const { schedules, types, scheduleMap, keyword, setKeyword, trigger } = useSchedule();
  const [open, handleOpen, handleClose] = useConfirmation();

  const [tabValue, setTabValue] = useState(0);
  const [selectedSchedule, setSelectedSchedule] = useState();
  const [firingTime, setFiringTime] = useState(null);

  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);
  };

  const search = (e) => {
    setKeyword(e.target.value);
  };

  const openTriggerConfirmation = (item) => (e) => {
    // display confirmation first
    setSelectedSchedule(item);
    handleOpen();
  };

  const onTrigger = (e) => {
    if (selectedSchedule) {
      trigger(selectedSchedule.id, selectedSchedule, !firingTime ? null : momentTz(firingTime, momentTz.tz.guess()).tz(selectedSchedule?.time_zone, true).valueOf()).then((resp) => {
        if (resp.ok) {
          setSelectedSchedule(null);
          setFiringTime(null);
          handleClose();
        }
      });
    }
  };

  const onChangeAttributes = (newAttributes) => {
    try {
      const newJson = JSON.parse(newAttributes);
      setSelectedSchedule(Object.assign(selectedSchedule, { attributes: newJson }));
    } catch (e) {
      // console.error(e);
    }
  };

  return (
    <Container maxWidth={false}>
      <Box sx={{ display: 'flex', flexDirection: 'row-reverse', marginTop: '10px' }}>
        <TextField onChange={search} value={keyword || ''} id="standard-basic" label="Search" />
      </Box>
      <Divider />
      <Grid container direction={isMobile ? 'column' : 'row'} spacing={1}>
        <Grid size={isMobile ? true : 2}>
          {types && (
            <Tabs
              orientation={isMobile ? 'horizontal' : 'vertical'}
              variant="scrollable"
              textColor="primary"
              indicatorColor="primary"
              value={tabValue}
              onChange={handleTabChange}
              className={classes.tabs}
            >
              {types.map((type) => (
                <Tab key={`label-${type}`} label={type} />
              ))}
            </Tabs>
          )}
        </Grid>
        <Grid size="grow">
          {types &&
            types.map((type, i) => (
              <TabPanel key={`type-${type}`} value={tabValue} index={i}>
                <ScheduleTable onTrigger={openTriggerConfirmation} items={scheduleMap[type]} />
              </TabPanel>
            ))}
        </Grid>
      </Grid>
      {selectedSchedule && (
        <Dialog open={open} onClose={handleClose} fullWidth={true} maxWidth={'md'} aria-labelledby="alert-dialog-title" aria-describedby="alert-dialog-description">
          <DialogTitle id="alert-dialog-title">Trigger Schedule {selectedSchedule.name ? selectedSchedule.name : ''}</DialogTitle>
          <DialogContent>
            <Grid container spacing={2}>
              <Grid size={6}>
                <Box>
                  <strong>ID</strong>
                </Box>
                <div>{selectedSchedule.id}</div>
              </Grid>
              <Grid size={6}>
                <Box>
                  <strong>Schedule</strong>
                </Box>
                <div>
                  {cronstrue.toString(selectedSchedule.schedule)}
                  <br />({selectedSchedule.schedule})
                </div>
              </Grid>
              <Grid size={6}>
                <Box>
                  <strong>Start</strong>
                </Box>
                <div>{selectedSchedule.start}</div>
              </Grid>
              <Grid size={6}>
                <Box>
                  <strong>End</strong>
                </Box>
                <div>{selectedSchedule.end}</div>
              </Grid>
              <Grid size={6}>
                <Box>
                  <strong>Time Zone</strong>
                </Box>
                <Box sx={{ mt: 2 }}>{selectedSchedule.time_zone}</Box>
              </Grid>

              <Grid size={6}>
                <Box>
                  <strong>Firing Time</strong>
                  <small style={{ marginLeft: 8 }}>(Default: Current time)</small>
                </Box>
                <Box sx={{ mt: 1 }}>
                  <AxlDateTimePicker value={firingTime} placeholder={'Select date & time'} ampm={false} onChange={(val) => setFiringTime(val)} handleDeleteDate={() => setFiringTime(null)} />
                </Box>
              </Grid>

              <Grid size={12}>
                <strong>Attributes</strong>
                <div>
                  <AceEditor
                    mode="json"
                    theme="github"
                    value={JSON.stringify(selectedSchedule.attributes, null, '\t')}
                    onChange={onChangeAttributes}
                    name="attributes"
                    width="100%"
                    height={400}
                    editorProps={{ $blockScrolling: true }}
                    setOptions={{
                      enableBasicAutocompletion: false,
                      enableLiveAutocompletion: false,
                      enableSnippets: false,
                    }}
                  />
                </div>
              </Grid>
            </Grid>
          </DialogContent>
          <DialogActions>
            <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
              <Box></Box>
              <Box>
                <Button onClick={handleClose} color="secondary" variant="outlined" style={{ marginRight: 8 }}>
                  Close
                </Button>
                <Button onClick={onTrigger} color="primary" autoFocus variant="contained" disableElevation>
                  Trigger
                </Button>
              </Box>
            </Box>
          </DialogActions>
        </Dialog>
      )}
    </Container>
  );
}

export default Schedule;
